import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { startTask } from "@sprout/client-lib/dist/loading";
const Loading = (props)=>{
    const { query  } = props;
    useEffect(()=>{
        const done = startTask("loading component via loadable-components");
        return ()=>{
            done(query);
        };
    }, [
        query
    ]);
    return null;
};
function getLoading(query = true) {
    return /*#__PURE__*/ _jsx(Loading, {
        query: query
    });
}
export default getLoading;
